import { compose, mapProps, lifecycle, createSink } from 'recompose';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import config from '../../../config';
import { type } from '../../Reducer';
import { withFetchOnMount } from '../../Common/Spinner';
import { isMuslimProStore } from '../Store/Store';
import { isCrawler } from '../../Common/Helpers/GetOs'
import { getQueryStringParam, getQueryParamsAndReappend } from '../../Ribbon/Ribbon';
import FrontendRedirectPaths from '../Helpers/FrontendRedirectPaths';

const multiCountriesStores = ['PBWW', 'PBEU'];
const { storeCode, localeApi } = config;

const getStoreDetails = () => $.get(`${localeApi}/store`)
  .fail((resp) => {
    const { errors = null } = resp.responseJSON;
    if (errors) {
      const msg = Object.keys(errors).map((key) => (errors[key].join(''))).join('<br/>');
      toastr.warning(msg);
    }
  });

const considerRedirect = () => {
  if (!multiCountriesStores.includes(storeCode)) return false;
  if (isCrawler()) return false;
  return true;
}

const handleRibbonRefer = (forceRedirectPaths) => {
  const { storeReferrerChoice, storeReferrerChoiceRemember } = getQueryStringParam();
  const { pathname } = window.location;

  if (storeReferrerChoiceRemember) {
    Cookies.set('storeReferrerChoiceRemember', 'true', { expires: 10 * 365 });
  }

  if (
    Cookies.get('storeReferrerChoiceRemember') || 
    storeReferrerChoice != null ||
    !forceRedirectPaths.includes(pathname)
  ) {
    return;
  }

  $.get(`${localeApi}/store/country`)
  .done((resp) => {
    if (!resp.data || !resp.data.code || !resp.data.url) {
      return;
    }
    if (multiCountriesStores.includes(resp.data.code)) {
      return;
    }
    let urlParams = `?referrer=${storeCode}`;
    urlParams = getQueryParamsAndReappend(urlParams);
    window.location.replace(resp.data.url + pathname + urlParams);
    return;
  });
};

export const withFetchStoreOnMount = compose(
  lifecycle({
    componentWillMount() {
      if (considerRedirect()) {
        /**
         * The goal is to redirect to close store if landed in multi countries stores. Will redirect IF AND ONLY IF
         * Current store is within the list
         * The user agent is not a crawler
         * No indication of user preferance to ignore redirect (whether from the cookie or the query params)
         * Path is from the force redirect paths provided by the config API
         * The store decided based on the IP by store/country API advises a different value from the ones in the list
        */
        FrontendRedirectPaths().then((response) => handleRibbonRefer(response));
      }
      getStoreDetails().then(({ data }) =>
        this.setState({ storeDetail: data }));
    },
    componentDidUpdate() {
      const { storeDetail = {} } = this.state;

      if (isMuslimProStore(storeDetail)) {
        document.body.classList.add('store--mpro');
      }
    },
  }),
);

export const mapStoreStateToProps = ({
  store = {
    logo: '',
    currency: {
      code: ''
    }
  }
}) => ({ store });

export const mapStoreDispatchToProps = dispatch => ({
  setStore: payload => dispatch({
    type: type.storeDetail,
    payload: {
      store: payload,
    }
  }),
});

export const withStoreDetail = connect(mapStoreStateToProps);

export const callback = ({ storeDetail, setStore }) => {
  setStore(storeDetail);
};

export const withBlockingFetchStoreOnMount = compose(
  withFetchOnMount(getStoreDetails),
  mapProps(({ loading, data, ...keys }) => ({
    store: data,
    ...keys
  })),
);

const enhance = compose(
  connect(null, mapStoreDispatchToProps),
  withFetchStoreOnMount,
);

export default enhance(createSink(callback));



// WEBPACK FOOTER //
// ./src/Common/Providers/WithStoreDetail.js